import React from 'react';
import DayJs from 'utils/Dayjs';

import Pill from 'components/Misc/Pill';
import Container from 'components/Misc/Container';
import { Title } from 'components/Misc/Typography';
import { Button } from 'components/Misc/Form';

import { useCourseProfileStore } from 'store/course/useCourseProfileStore';

const Information = () => {
	// Use course's profile store
	const [webinars, subject] = useCourseProfileStore(state => [state.webinars, state.subject]);

	// Do not display anything if there are no webinars
	if (!webinars?.length) return null;

	return (
		<Container className="p-4 flex flex-col gap-4">
			{webinars?.map(webinar =>
				<div key={webinar.id} className="flex items-center space-x-2">
					<div className="flex-1 overflow-hidden space-y-2">
						<Title
							title={webinar.title}
							subtitle={subject.title}
							className="flex-1 whitespace-nowrap text-ellipsis overflow-hidden"
						/>

						<Pill
							theme="informative"
							name={DayJs(webinar.eventAt).format('D. MMMM, YYYY')}
						/>
					</div>

					<Button
						small
						square
						icon="link"
						to={`/webinars/${webinar.id}`}
					/>
				</div>
			)}
		</Container>
	);
};

export default Information;